export const articulosSelector = (state: $TSMigrationFixMe) => state.articulos
